module.exports = __webpack_public_path__ + "img/logo_cfcu.c8c0f530.png";